var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"title":"menu.brands"}}),_c('brand-table',{ref:"table",scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('create-button',{attrs:{"route-name":_vm.routeType.BRAND_CREATE}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }